import React, { useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const StatItem = ({
  value,
  label,
  prefix = '',
  suffix = ''
}: {
  value: number;
  label: string;
  prefix?: string;
  suffix?: string;
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <div ref={ref} className="text-center p-6 bg-zinc-900/50 rounded-xl border border-zinc-800 backdrop-blur-sm hover:bg-zinc-900 transition-all" data-id="element-37">
      <div className="text-4xl md:text-5xl font-bold text-white mb-2 flex justify-center items-center" data-id="element-38">
        {prefix}
        {isInView && <Counter from={0} to={value} duration={2} data-id="element-39" />}
        {suffix}
      </div>
      <div className="text-zinc-500 font-medium uppercase tracking-wide text-sm" data-id="element-40">
        {label}
      </div>
    </div>;
};
const Counter = ({
  from,
  to,
  duration
}: {
  from: number;
  to: number;
  duration: number;
}) => {
  const nodeRef = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    const node = nodeRef.current;
    if (!node) return;
    const controls = {
      value: from,
      stop: false
    };
    const startTime = performance.now();
    const animate = (currentTime: number) => {
      if (controls.stop) return;
      const elapsed = (currentTime - startTime) / 1000;
      const progress = Math.min(elapsed / duration, 1);
      // Ease out quart
      const ease = 1 - Math.pow(1 - progress, 4);
      const current = Math.floor(from + (to - from) * ease);
      node.textContent = current.toLocaleString();
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
    return () => {
      controls.stop = true;
    };
  }, [from, to, duration]);
  return <span ref={nodeRef} data-id="element-41" />;
};
export function AnimatedStats() {
  return <section className="relative py-12 px-4 sm:px-6 lg:px-8 overflow-hidden border-b border-zinc-900 bg-black" data-id="element-42">
      <div className="max-w-7xl mx-auto" data-id="element-43">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-44">
          <StatItem value={127} prefix="$" suffix="M+" label="Total Funded" data-id="element-45" />
          <StatItem value={3400} suffix="+" label="Businesses Helped" data-id="element-46" />
          <StatItem value={72} suffix=" Hr" label="Avg Approval" data-id="element-47" />
          <StatItem value={96} suffix="%" label="Satisfaction Rate" data-id="element-48" />
        </div>
      </div>
    </section>;
}